import React, { useState } from 'react';
import styles from './phiosophy.module.css';
import { Helmet } from 'react-helmet';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios, { post } from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress, adaptV4Theme } from '@mui/material';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import AdminNav from '../AdminDashboard/AdminNav';
import Public401kTable from './components/Public401kTable';
import EditPublic401kModal from './components/EditPublic401kModal';
import Public403bTable from './components/Public403bTable';
import EditPublic403bModal from './components/EditPublic403bModal';
import {
  BLUE_PLOOT,
  DANGER_RED,
  ERROR_OCCURED,
  facebook_login,
  GENERAL_GRAPH,
  getEditAssumptionsInitialState,
  getUser,
  get_clients,
  google_login,
  login_user,
  sendAlert,
  SEND_ALERT,
  TEXT_BLACK,
  tokenSelector,
  WHITE,
  resendActivationEmail,
  RESET_GENERAL,
} from '@plootus/common';
const Admin = (props) => {
  window.scrollTo(0, 0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('employer');
  const [employerFiles, setEmployerFiles] = useState(null);
  const [allocationFiles, setAllocationFiles] = useState(null);
  const [public401kFiles, setPublic401kFiles] = useState(null);
  const [public403bFiles, setPublic403bFiles] = useState(null);
  const [public401kData, setPublic401kData] = useState([]);
  const [public403bData, setPublic403bData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [isEdit403bModalOpen, setIsEdit403bModalOpen] = useState(false);
  const [selected403bRow, setSelected403bRow] = useState(null);
  const [edit403bLoading, setEdit403bLoading] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [isDeleteAllModalOpen, setIsDeleteAllModalOpen] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');

  const dispatch = useDispatch();

  const fetchPublic401kData = React.useCallback(async () => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;
    try {
      setTableLoading(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}public401k/all`;
      const res = await axios.get(url, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        setPublic401kData(res.data);
      }
    } catch (err) {
      console.error('Error fetching public 401k data:', err);
    } finally {
      setTableLoading(false);
    }
  }, []);

  const fetchPublic403bData = React.useCallback(async () => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;
    try {
      setTableLoading(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}public403b/all`;
      const res = await axios.get(url, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        setPublic403bData(res.data);
      }
    } catch (err) {
      console.error('Error fetching public 403b data:', err);
    } finally {
      setTableLoading(false);
    }
  }, []);

  const handleDeletePublic401k = async (id) => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}public401k/${id}`;
      const res = await axios.delete(url, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        dispatch({
          type: SEND_ALERT,
          payload: {
            title: 'Delete Success',
            textContent: 'Data successfully deleted',
          },
        });
        fetchPublic401kData();
      }
    } catch (err) {
      console.error('Error deleting public 401k data:', err);
      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Delete Error',
          textContent: 'An error occurred during deletion',
        },
      });
    }
  };

  const handleDeletePublic403b = async (id) => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}public403b/${id}`;
      const res = await axios.delete(url, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        dispatch({
          type: SEND_ALERT,
          payload: {
            title: 'Delete Success',
            textContent: 'Data successfully deleted',
          },
        });
        fetchPublic403bData();
      }
    } catch (err) {
      console.error('Error deleting public 403b data:', err);
      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Delete Error',
          textContent: 'An error occurred during deletion',
        },
      });
    }
  };

  const handleDeleteAllPublic403b = async () => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;

    if (deleteConfirmText !== 'DELETE ALL 403B DATA') {
      return;
    }

    try {
      setTableLoading(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}public403b/all`;
      const res = await axios.delete(url, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        dispatch({
          type: SEND_ALERT,
          payload: {
            title: 'Delete Success',
            textContent: 'All 403b data successfully deleted',
          },
        });
        setIsDeleteAllModalOpen(false);
        setDeleteConfirmText('');
        fetchPublic403bData();
      }
    } catch (err) {
      console.error('Error deleting all public 403b data:', err);
      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Delete Error',
          textContent: 'An error occurred during mass deletion',
        },
      });
    } finally {
      setTableLoading(false);
    }
  };

  const handleEditRow = (row) => {
    setSelectedRow(row);
    setIsEditModalOpen(true);
  };

  const handleEdit403bRow = (row) => {
    setSelected403bRow(row);
    setIsEdit403bModalOpen(true);
  };

  const handleSaveEdit = async (id, updatedData) => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;
    try {
      setEditLoading(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}public401k/${id}`;
      const res = await axios.put(url, updatedData, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        dispatch({
          type: SEND_ALERT,
          payload: {
            title: 'Update Success',
            textContent: 'Data successfully updated',
          },
        });
        setIsEditModalOpen(false);
        fetchPublic401kData();
      }
    } catch (err) {
      console.error('Error updating public 401k data:', err);
      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Update Error',
          textContent: 'An error occurred during update',
        },
      });
    } finally {
      setEditLoading(false);
    }
  };

  const handleSave403bEdit = async (id, updatedData) => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) return;
    try {
      setEdit403bLoading(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}public403b/${id}`;
      const res = await axios.put(url, updatedData, {
        headers: {
          Authorization: adminToken,
        },
      });
      if (res.status === 200) {
        dispatch({
          type: SEND_ALERT,
          payload: {
            title: 'Update Success',
            textContent: 'Data successfully updated',
          },
        });
        setIsEdit403bModalOpen(false);
        fetchPublic403bData();
      }
    } catch (err) {
      console.error('Error updating public 403b data:', err);
      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Update Error',
          textContent: 'An error occurred during update',
        },
      });
    } finally {
      setEdit403bLoading(false);
    }
  };

  React.useEffect(() => {
    if (activeTab === 'public401k') {
      fetchPublic401kData();
    } else if (activeTab === 'public403b') {
      fetchPublic403bData();
    }
  }, [activeTab, fetchPublic401kData, fetchPublic403bData]);

  const theme = createTheme(
    adaptV4Theme({
      palette: {
        primary: { main: BLUE_PLOOT },
      },
      typography: { useNextVariants: true },
    })
  );

  const handleUploadFile = (event) => {
    if (activeTab === 'employer') {
      setEmployerFiles(event.target.files);
    } else if (activeTab === 'allocation') {
      setAllocationFiles(event.target.files);
    } else if (activeTab === 'public401k') {
      setPublic401kFiles(event.target.files);
    } else {
      setPublic403bFiles(event.target.files);
    }
  };

  const handleUnsubscribe = async () => {
    const formData = new FormData();
    let currentFiles;
    if (activeTab === 'employer') currentFiles = employerFiles;
    else if (activeTab === 'allocation') currentFiles = allocationFiles;
    else if (activeTab === 'public401k') currentFiles = public401kFiles;
    else currentFiles = public403bFiles;

    if (!currentFiles || currentFiles.length === 0) {
      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Upload Error',
          textContent: 'Please select an Excel file first',
        },
      });
      return;
    }

    let url;
    let config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    if (activeTab === 'public401k') {
      url = `${process.env.REACT_APP_API_BASE_URL}public401k/upload`;
      formData.append('file', currentFiles[0]);
      const adminToken = localStorage.getItem('admin_token');
      if (adminToken) {
        config.headers['Authorization'] = adminToken;
      }
    } else if (activeTab === 'public403b') {
      url = `${process.env.REACT_APP_API_BASE_URL}public403b/upload`;
      formData.append('file', currentFiles[0]);
      const adminToken = localStorage.getItem('admin_token');
      if (adminToken) {
        config.headers['Authorization'] = adminToken;
      }
    } else {
      url = `${process.env.REACT_APP_API_BASE_URL}uploadxldata`;
      formData.append(
        'uploadType',
        activeTab === 'employer' ? 'employer' : 'allocation'
      );
      for (let i = 0; i < currentFiles.length; i++) {
        formData.append('files', currentFiles[i]);
      }
    }

    try {
      setLoading(true);
      const res = await axios.post(url, formData, config);

      if (res.status === 200) {
        dispatch({
          type: SEND_ALERT,
          payload: {
            title: 'Upload Success',
            textContent: 'File was successfully uploaded',
          },
        });
        // Clear files after successful upload
        setEmployerFiles(null);
        setAllocationFiles(null);
        setPublic401kFiles(null);
        setPublic403bFiles(null);
        setFileInputKey(Date.now());

        if (activeTab === 'public401k') {
          fetchPublic401kData();
        } else if (activeTab === 'public403b') {
          fetchPublic403bData();
        }
      }
    } catch (err) {
      const status = err.response?.status;
      let errorMessage = 'An error occurred during upload';

      if (status === 500) {
        errorMessage = 'Please upload only Excel files';
      } else if (status === 400) {
        errorMessage = 'Please select a valid Excel file';
      }

      dispatch({
        type: SEND_ALERT,
        payload: {
          title: 'Upload Error',
          textContent: errorMessage,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <AdminNav {...props} />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Admin - Excel Upload</title>
      </Helmet>

      <div className={styles.tabsContainer}>
        <div
          className={`${styles.tab} ${activeTab === 'employer' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('employer')}
        >
          Upload Employer
        </div>
        <div
          className={`${styles.tab} ${activeTab === 'allocation' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('allocation')}
        >
          Upload Allocation
        </div>
        <div
          className={`${styles.tab} ${activeTab === 'public401k' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('public401k')}
        >
          Upload Public 401k
        </div>
        <div
          className={`${styles.tab} ${activeTab === 'public403b' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('public403b')}
        >
          Upload Public 403b
        </div>
      </div>

      <div className={styles.uploadContainer}>
        <h4 className={styles.uploadTitle}>
          {activeTab === 'employer'
            ? 'Employer Data Upload'
            : activeTab === 'allocation'
              ? 'Allocation Data Upload'
              : activeTab === 'public401k'
                ? 'Public 401k Data Upload'
                : 'Public 403b Data Upload'}
        </h4>
        <div className={styles.uploadActionRow}>
          <input
            type="file"
            className={styles.fileInput}
            onChange={handleUploadFile}
            multiple={activeTab !== 'public401k' && activeTab !== 'public403b'}
            key={`${activeTab}-${fileInputKey}`} // Reset input when tab changes or after successful upload
          />

          <div className={styles.login}>
            {loading ? (
              <div className={styles.loader}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={theme}>
                    <CircularProgress size={40} />
                  </ThemeProvider>
                </StyledEngineProvider>
              </div>
            ) : (
              <button
                type="submit"
                onClick={handleUnsubscribe}
                className={styles.loginButton}
                disabled={
                  activeTab === 'employer'
                    ? !employerFiles
                    : activeTab === 'allocation'
                      ? !allocationFiles
                      : activeTab === 'public401k'
                        ? !public401kFiles
                        : !public403bFiles
                }
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>

      {activeTab === 'public401k' && (
        <>
          <Public401kTable
            data={public401kData}
            loading={tableLoading}
            onDelete={handleDeletePublic401k}
            onEdit={handleEditRow}
          />
          <EditPublic401kModal
            isOpen={isEditModalOpen}
            onClose={() => setIsEditModalOpen(false)}
            data={selectedRow}
            onSave={handleSaveEdit}
            loading={editLoading}
          />
        </>
      )}

      {activeTab === 'public403b' && (
        <>
          <Public403bTable
            data={public403bData}
            loading={tableLoading}
            onDelete={handleDeletePublic403b}
            onEdit={handleEdit403bRow}
          />

          <EditPublic403bModal
            isOpen={isEdit403bModalOpen}
            onClose={() => setIsEdit403bModalOpen(false)}
            data={selected403bRow}
            onSave={handleSave403bEdit}
            loading={edit403bLoading}
          />

          {public403bData && public403bData.length > 0 && (
            <div className={styles.dangerZone}>
              <div className={styles.dangerZoneHeader}>
                <h4 className={styles.dangerZoneTitle}>Danger Zone</h4>
                <p className={styles.dangerZoneDescription}>
                  Irreversible actions that affect the entire Public 403b dataset.
                </p>
              </div>
              <div className={styles.dangerZoneAction}>
                <div className={styles.dangerZoneText}>
                  <strong>Delete all data</strong>
                  <span>Once you delete all data, there is no going back. Please be certain.</span>
                </div>
                <button
                  className={styles.deleteAllButton}
                  onClick={() => setIsDeleteAllModalOpen(true)}
                >
                  Delete All 403b Data
                </button>
              </div>
            </div>
          )}

          {isDeleteAllModalOpen && (
            <div className={styles.modalOverlay}>
              <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                  <h3 className={styles.modalTitle}>Are you absolutely sure?</h3>
                  <button
                    className={styles.closeButton}
                    onClick={() => {
                      setIsDeleteAllModalOpen(false);
                      setDeleteConfirmText('');
                    }}
                  >
                    &times;
                  </button>
                </div>
                <div className={styles.modalBody}>
                  <p className={styles.modalWarning}>
                    This action <strong>CANNOT</strong> be undone. This will permanently delete all records in the Public 403b database.
                  </p>
                  <p className={styles.modalInstruction}>
                    Please type <strong>DELETE ALL 403B DATA</strong> to confirm.
                  </p>
                  <input
                    type="text"
                    className={styles.formInput}
                    value={deleteConfirmText}
                    onChange={(e) => setDeleteConfirmText(e.target.value)}
                    placeholder="Type the confirmation text"
                  />
                </div>
                <div className={styles.modalFooter}>
                  <button
                    className={styles.cancelButton}
                    onClick={() => {
                      setIsDeleteAllModalOpen(false);
                      setDeleteConfirmText('');
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className={styles.saveButton}
                    style={{
                      backgroundColor: deleteConfirmText === 'DELETE ALL 403B DATA' ? '#ef4444' : '#94a3b8',
                      cursor: deleteConfirmText === 'DELETE ALL 403B DATA' ? 'pointer' : 'not-allowed'
                    }}
                    disabled={deleteConfirmText !== 'DELETE ALL 403B DATA' || tableLoading}
                    onClick={handleDeleteAllPublic403b}
                  >
                    {tableLoading ? 'Deleting...' : 'I understand the consequences, delete all data'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Admin;
